import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import { createCategory } from '../../graphql/mutation';
import {
  Card,
  Form,
  Input,
  InputNumber,
  Button,
  Space,
  Row,
  Col,
  Radio,
  Select
} from 'antd';
import { showSnackBar } from '../../components/SnackBar/SnackBar';
import './CreateCategory.css';

const { TextArea } = Input;
const { Option } = Select;

const CreateCategory = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const [createCategoryMutation] = useMutation(createCategory);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      await createCategoryMutation({
        variables: {
          name: values.name,
          description: values.description,
          rowNumber: values.rowNumber,
          skipTranslation: values.skipTranslation || false,
          type: values.type || null
        }
      });

      showSnackBar('success', 'Success', 'Category created successfully');
      navigate('/categories');
    } catch (error) {
      showSnackBar('error', 'Error', error.message || 'Failed to create category');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-category-container">
      <Card title="Create Category">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: 'Please enter category name' }]}
              >
                <Input placeholder="Enter category name" />
              </Form.Item>

              <Form.Item
                name="skipTranslation"
                label="Translation"
                initialValue={false}
              >
                <Radio.Group>
                  <Radio value={false}>Auto translate</Radio>
                  <Radio value={true}>Do not translate (use original name)</Radio>
                </Radio.Group>
              </Form.Item>

              <Form.Item
                name="description"
                label="Description"
              >
                <TextArea 
                  rows={4} 
                  placeholder="Enter category description (optional)" 
                />
              </Form.Item>

              <Form.Item
                name="rowNumber"
                label="Row Number"
                rules={[{ required: true, message: 'Please enter row number' }]}
              >
                <InputNumber
                  min={1}
                  placeholder="Enter row number"
                  style={{ width: '100%' }}
                />
              </Form.Item>

              <Form.Item
                name="type"
                label="Content Type"
                extra="Used by rule-based Tabs to filter categories (e.g. only VIDEO categories)"
              >
                <Select placeholder="Select content type" allowClear>
                  <Option value="VIDEO">Video</Option>
                  <Option value="IMAGE">Image</Option>
                  <Option value="MIX">Mix</Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Create Category
              </Button>
              <Button onClick={() => navigate('/categories')}>
                Cancel
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default CreateCategory; 